import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f7ec01a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-site-timings bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-row pt-6 pb-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Tempo viaggio per il cantiere")
], -1))
const _hoisted_6 = { class: "add-input flex" }
const _hoisted_7 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_8 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_9 = { class: "timing-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_WorkingSiteTimingCard = _resolveComponent("WorkingSiteTimingCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "header w-full fixed relative inline-flex cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _createVNode(_component_LeftArrow, { class: "back-arrow" }),
          _hoisted_4
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["text px-4 py-3 flex-grow", { border: _ctx.v$.timing.$error }]),
            type: "text",
            placeholder: "HH:mm",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timing) = $event)),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.timing.$touch && _ctx.v$.timing.$touch(...args)))
          }, null, 34), [
            [_vModelText, _ctx.timing]
          ]),
          _createVNode(_component_PrimaryButton, {
            class: "button bg-white text-primary flex-none",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addTiming()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Aggiungi Tempo viaggio")
            ]),
            _: 1
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.timing.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errors text-left",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_7, "È necessario specificare le ore di viaggio"))
              : _createCommentVNode("", true),
            (error.$validator == 'format')
              ? (_openBlock(), _createElementBlock("label", _hoisted_8, "Il formato inserito non è valido. Il tempo di viaggio deve essere inserito nel formato HH:mm (ore e minuti separati dal carattere due punti)."))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timings, (timing) => {
            return (_openBlock(), _createBlock(_component_WorkingSiteTimingCard, { "model-value": timing }, null, 8, ["model-value"]))
          }), 256))
        ])
      ])
    ])
  ]))
}